import { h, defineComponent } from 'vue';
import { t } from '@/ui/i18n/i18n';

export const SeeErrorLogsLink = defineComponent({
  name: 'SeeErrorLogsLink',
  setup(props, ctx) {
    return function render() {
      return h('a', {
        attrs: {
          class: 'see-error-logs-link',
          href: '#',
          target: '_blank',
        },
        on: {
          click: (ev: MouseEvent) => ctx.emit('click', ev),
        },
      }, [
        h('span', [t('sso.scim.see-error-logs')]),
      ]);
    };
  },
});
